import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { DEFAULT_INTERRUPTSOURCES, Idle } from '@ng-idle/core';
import { Keepalive } from '@ng-idle/keepalive';
import { CookieService } from 'ngx-cookie-service';

@Injectable({
  providedIn: 'root',
})
export class IdleService {
  title = 'ng-arkik';
  idleState = 'Not started.';
  timedOut = false;
  lastPing?: Date = undefined;

  constructor(
    private idle: Idle,
    private keepalive: Keepalive,
    private router: Router,
    private cookieService: CookieService,
  ) {
    idle.setIdle(1000);
    idle.setTimeout(1000);
    idle.setInterrupts(DEFAULT_INTERRUPTSOURCES);

    idle.onIdleEnd.subscribe(() => {
      this.idleState = 'No longer idle.';
      this.reset();
    });

    idle.onTimeout.subscribe(() => {
      this.idleState = 'Timed out!';
      this.timedOut = true;
      this.cookieService.deleteAll();
      this.router.navigate(['/login'], { replaceUrl: true });
    });

    idle.onIdleStart.subscribe(() => {
      this.idleState = "You've gone idle!";
      //this.childModal.show();
    });

    idle.onTimeoutWarning.subscribe((countdown) => {
      this.idleState = 'You will time out in ' + countdown + ' seconds!';
    });

    // sets the ping interval to 15 seconds
    keepalive.interval(15);
    keepalive.onPing.subscribe(() => (this.lastPing = new Date()));
    this.reset();
  }

  reset() {
    this.idle.watch();
    this.idleState = 'Started.';
    this.timedOut = false;
  }
}
